import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RootState } from "../store";
import { useSelector } from "react-redux";

const PrivateRoute = (): JSX.Element => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user);

  const isAuthenticated = (): boolean => !!user.id;

  const publicPaths = ["/legal/privacy-policy", "/legal/terms-of-service"];

  const isPublicPath = (): boolean => {
    return publicPaths.some((path) => location.pathname.startsWith(path));
  };

  if (!isAuthenticated() && !isPublicPath()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
